(function() {
  var UPSELL_LIMIT = 2;
  var upsellProductsCache = null;
  var lastFetchedProductId = null;
  var isFetching = false;

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u20AC';
  }

  function getUpsellContainer() {
    return document.getElementById('CartDrawer-Upsell');
  }

  function getFirstCartProductId() {
    var container = getUpsellContainer();
    if (!container) return null;
    var id = container.getAttribute('data-first-product-id');
    return id && id.trim() !== '' ? id.trim() : null;
  }

  function fetchAndRenderUpsells(productId, force) {
    if (!productId) {
      clearUpsell();
      return;
    }

    /* If same product and we have cache, render from cache */
    if (!force && productId === lastFetchedProductId && upsellProductsCache) {
      renderUpsellProducts(upsellProductsCache);
      return;
    }

    if (isFetching) return;
    isFetching = true;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + (UPSELL_LIMIT + 2) + '&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        isFetching = false;
        var products = (data.products || []).slice(0, UPSELL_LIMIT);
        lastFetchedProductId = productId;
        upsellProductsCache = products;
        renderUpsellProducts(products);
      })
      .catch(function(err) {
        isFetching = false;
        console.error('Cart upsell fetch error:', err);
      });
  }

  function clearUpsell() {
    var container = getUpsellContainer();
    if (container) container.innerHTML = '';
  }

  function renderUpsellProducts(products) {
    var container = getUpsellContainer();
    if (!container) return;

    if (!products || products.length === 0) {
      container.innerHTML = '';
      return;
    }

    var html = '<p class="cart-drawer-upsell__heading">Vous aimerez aussi</p>';
    html += '<div class="cart-drawer-upsell__products">';

    products.forEach(function(product) {
      var availableVariants = product.variants.filter(function(v) { return v.available; });
      var firstAvailable = availableVariants.length > 0 ? availableVariants[0] : product.variants[0];
      var imgUrl = product.featured_image || '';
      var image = imgUrl.indexOf('?') > -1 ? imgUrl + '&width=200' : imgUrl + '?width=200';
      var hasVariants = availableVariants.length > 1;

      html += '<div class="cart-drawer-upsell__product">';
      html += '<img class="cart-drawer-upsell__product-image" src="' + image + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">';
      html += '<a href="' + product.url + '" class="cart-drawer-upsell__product-title">' + product.title + '</a>';

      var priceHtml = '';
      if (firstAvailable.compare_at_price && firstAvailable.compare_at_price > firstAvailable.price) {
        priceHtml = '<s>' + formatMoney(firstAvailable.compare_at_price) + '</s> ' + formatMoney(firstAvailable.price);
      } else {
        priceHtml = formatMoney(firstAvailable.price);
      }
      html += '<span class="cart-drawer-upsell__product-price" data-upsell-price="' + product.id + '">' + priceHtml + '</span>';

      if (hasVariants) {
        html += '<select class="cart-drawer-upsell__variant-select" data-upsell-variant-select="' + product.id + '" aria-label="Variante pour ' + product.title.replace(/"/g, '&quot;') + '">';
        availableVariants.forEach(function(v) {
          var selected = v.id === firstAvailable.id ? ' selected' : '';
          html += '<option value="' + v.id + '" data-price="' + v.price + '" data-compare-price="' + (v.compare_at_price || '') + '"' + selected + '>' + v.title + '</option>';
        });
        html += '</select>';
      }

      html += '<button class="cart-drawer-upsell__add-btn" data-upsell-add="' + product.id + '" data-variant-id="' + firstAvailable.id + '" type="button">Ajouter au panier</button>';
      html += '</div>';
    });

    html += '</div>';
    container.innerHTML = html;
    bindUpsellEvents();
  }

  function bindUpsellEvents() {
    var container = getUpsellContainer();
    if (!container) return;

    container.querySelectorAll('[data-upsell-variant-select]').forEach(function(select) {
      select.addEventListener('change', function() {
        var productId = this.dataset.upsellVariantSelect;
        var selectedOption = this.options[this.selectedIndex];
        var variantId = this.value;
        var price = parseInt(selectedOption.dataset.price);
        var comparePrice = selectedOption.dataset.comparePrice ? parseInt(selectedOption.dataset.comparePrice) : null;

        var btn = container.querySelector('[data-upsell-add="' + productId + '"]');
        if (btn) btn.dataset.variantId = variantId;

        var priceEl = container.querySelector('[data-upsell-price="' + productId + '"]');
        if (priceEl) {
          if (comparePrice && comparePrice > price) {
            priceEl.innerHTML = '<s>' + formatMoney(comparePrice) + '</s> ' + formatMoney(price);
          } else {
            priceEl.innerHTML = formatMoney(price);
          }
        }
      });
    });

    container.querySelectorAll('[data-upsell-add]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = this.dataset.variantId;
        addToCart(variantId, this);
      });
    });
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = originalText;
      btn.disabled = false;
      refreshCartDrawer();
    })
    .catch(function(err) {
      console.error('Upsell add to cart error:', err);
      btn.textContent = originalText;
      btn.disabled = false;
    });
  }

  function refreshCartDrawer() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    fetch(root + 'cart?section_id=cart-drawer')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        /* Replace the drawer inner content the same way CartDrawerItems does */
        var newDrawerInner = doc.querySelector('.drawer__inner');
        var currentDrawerInner = document.querySelector('cart-drawer .drawer__inner');
        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        }

        /* Update cart icon bubble */
        var newBubble = doc.getElementById('cart-icon-bubble');
        var currentBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }

        /* Toggle empty state */
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          var isEmpty = doc.querySelector('cart-drawer-items.is-empty');
          cartDrawer.classList.toggle('is-empty', !!isEmpty);
        }

        /* Re-init upsell after DOM is updated */
        initUpsell();
      })
      .catch(function(err) {
        console.error('Cart drawer refresh error:', err);
      });
  }

  function initUpsell() {
    var productId = getFirstCartProductId();
    if (productId) {
      fetchAndRenderUpsells(productId);
    } else {
      clearUpsell();
    }
  }

  /**
   * Monkey-patch CartDrawer.renderContents to trigger upsell after the drawer
   * content is replaced and the drawer opens. This is the key fix:
   * When a product is added to cart, product-form.js calls cart.renderContents()
   * which replaces #CartDrawer innerHTML. We need to populate the upsell after that.
   */
  function patchCartDrawer() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;

    var originalRenderContents = cartDrawerEl.renderContents;
    if (!originalRenderContents) return;

    cartDrawerEl.renderContents = function(parsedState) {
      /* Call the original renderContents first */
      originalRenderContents.call(this, parsedState);

      /* After renderContents replaces innerHTML and schedules open(),
         we need to wait for the DOM to settle then init upsell.
         renderContents uses setTimeout for open(), so we use a slightly longer timeout. */
      setTimeout(function() {
        initUpsell();
      }, 100);
    };
  }

  /**
   * Also patch CartDrawerItems (the custom element for quantity changes).
   * When quantity is updated, CartDrawerItems.onCartUpdate() replaces .drawer__inner innerHTML.
   * After that replacement, our upsell container exists but is empty.
   */
  function patchCartDrawerItems() {
    var cartDrawerItemsEl = document.querySelector('cart-drawer-items');
    if (!cartDrawerItemsEl) return;

    var originalOnCartUpdate = cartDrawerItemsEl.onCartUpdate;
    if (!originalOnCartUpdate) return;

    cartDrawerItemsEl.onCartUpdate = function() {
      var result = originalOnCartUpdate.call(this);
      /* onCartUpdate returns a promise */
      if (result && result.then) {
        result.then(function() {
          setTimeout(function() {
            initUpsell();
          }, 50);
        });
      }
      return result;
    };
  }

  /**
   * Subscribe to the PubSub cartUpdate event as a fallback.
   * This fires when product-form.js publishes after add-to-cart.
   */
  function subscribeToCartUpdate() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
        /* Wait for the DOM to be updated by other subscribers (CartDrawerItems) */
        setTimeout(function() {
          initUpsell();
        }, 500);
      });
    }
  }

  /**
   * Watch for the cart drawer becoming active (visible) as another fallback.
   * This catches cases where the drawer opens but upsell wasn't populated.
   */
  function watchDrawerOpen() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;

    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'class') {
          if (cartDrawerEl.classList.contains('active')) {
            /* Drawer just became active - check if upsell needs populating */
            setTimeout(function() {
              var container = getUpsellContainer();
              if (container) {
                var productsDiv = container.querySelector('.cart-drawer-upsell__products');
                if (!productsDiv || productsDiv.children.length === 0) {
                  initUpsell();
                }
              }
            }, 150);
          }
        }
      }
    });

    observer.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* Initialize everything */
  function setup() {
    patchCartDrawer();
    patchCartDrawerItems();
    subscribeToCartUpdate();
    watchDrawerOpen();
    initUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();